import { Autocomplete, Box, Button, Grid, TextField } from '@mui/material'
import React, { FormEvent, useEffect, useState } from 'react'
import clientConfigState, { ClientData } from '../atoms/clientConfigState'
import { useLocation, useNavigate } from 'react-router-dom'
import { useRecoilValue } from 'recoil'
// eslint-disable-next-line sort-imports
import ClientsService from '../service/clients'
import { Heading1 }  from './ClientConfigToolStyles'
import Notification from '../util/Notification'


function ClientConfigTool() {
  const navigate = useNavigate()
  const location = useLocation()
  const clientState = useRecoilValue(clientConfigState)
  const [client, setClient] = useState<ClientData|null>(null)
  const [allClients, setAllClients] = useState<ClientData[]>([])
  const [allClientsError, setAllClientsError] = useState(false)
  const [allClientsPlaceholder, setAllClientsPlaceholder] =
		useState('Loading...')

  const handleSubmit = (event: FormEvent, type: string) => {
    event.preventDefault()
    navigate(`${type === 'wotc' ? 'wotc/' : ''}${client.client_id}`, { state: { client } })
  }
  
  useEffect(() => {
    window.history.replaceState({}, '')
    if (allClients.length < 1) {
      ClientsService
        .getAllClients()
        .then(function (result) {
          setAllClients(result)
          setAllClientsError(false)
          setAllClientsPlaceholder('Client')
        })
        .catch(function () {
          setAllClientsError(true)
          setAllClientsPlaceholder('Error loading clients...')
        })
    }
    setClient(null)
  }, [clientState.data.client_id])

  const { state } = location

  return (
    <div>
      <Box padding={6}>
        {state && state.error
          && (
            <Notification
              description={state.error}
              severity='error'
              title='Error'
            />
          )
        }
        <form>
          <Grid
            container
            direction="column"
            justifyContent="space-around"
            spacing={4}
          > 
            <Grid item>
              <Heading1>Client Configuration Tool</Heading1>
            </Grid>
            <Grid container item spacing={1} xs={12}>
              <Grid item xs={6}>
                <Autocomplete
                  data-testid="autocomplete-cct"
                  disabled={allClientsError}
                  getOptionLabel={option => option.label}
                  id="clientSearch"
                  onChange={(event, val) => setClient(val)}
                  options={allClients}
                  renderInput={params => (
                    <TextField
                      {...params}
                      data-testid="textfield-cct"
                      error={allClientsError}
                      helperText="Search by either client name or client ID"
                      label={allClientsPlaceholder}
                      placeholder="Client"
                    />
                  )}
                  value={client}
                />
              </Grid>
            </Grid>
            <Grid container item spacing={1} xs={12}>
              <Grid item xs={3}>
                <Button
                  color="primary"
                  disabled={!client}
                  onClick={(e) => handleSubmit(e, 'trackeri9')}
                  type="button"
                  variant="contained"                  
                >
									Configure client settings
                </Button>
              </Grid>
              <Grid item xs={3}>
                <Button
                  color="primary"
                  disabled={!client}
                  onClick={(e) => handleSubmit(e, 'wotc')}
                  type="button"
                  variant="contained"                  
                >
									Configure WOTC
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </form>
      </Box>
    </div>
  )
}

export default ClientConfigTool
